import React, { useEffect, useState } from "react";

const TOKEN_KEY = "JWT";

export const AuthGate: React.FC<{ children: React.ReactNode }> = ({ children }) => {
    const [ready, setReady] = useState(false);
    const [error, setError] = useState < string | null > (null);

    useEffect(() => {
        let tries = 0;

        const check = () => {
            const raw = sessionStorage.getItem(TOKEN_KEY);
            if (raw) {
                setReady(true);
                return;
            }
            tries++;
            if (tries < 2) {
                setTimeout(check, 1000);
            } else {
                setError("No JWT in sessionStorage");
            }
        };

        check();
    }, []);

    if (error) return <>{error}</>;
    if (!ready) return <>Loading…</>;
    return <>{children}</>;
};
